import { FC, useState } from "react";

import { IBandUser } from "Bands/types";
import { getMemberName } from "Bands/utils";
import { Tooltip } from "shared/components";

import { StyledMemberName } from "./styles";
import { MutedDarkText, TinyText } from "shared/styles";
import { useBandContext } from "Bands/contexts";

interface MemberNameProps {
  user: IBandUser;
}

export const MemberName: FC<MemberNameProps> = ({ user }) => {
  const [referenceElement, setReferenceElement] = useState<Element | null>();
  const { getCategory } = useBandContext();

  return (
    <StyledMemberName ref={setReferenceElement}>
      {getMemberName(user)}
      {user && (
        <Tooltip
          content={
            <span>
              <TinyText>
                {user.firstname} {user.lastname}{" "}
              </TinyText>
              {(user.function || user.category) && (
                <TinyText as={MutedDarkText}>
                  {user.function} {user.category && <>({getCategory(user.category.id)?.label})</>}
                </TinyText>
              )}
            </span>
          }
          referenceElement={referenceElement}
          placement="top"
        />
      )}
    </StyledMemberName>
  );
};
